import campagnesReducer from "../campagnesReducer";
import paramDomainesThemesReducer from "../paramDomainesThemesReducer";
import formationsReducer from "../formationsReducer";
import cataloguesReducer from "../cataloguesReducer";
import capsuleReducer from "../capsuleReducer";
import demandesReducer from "../demandesReducer";
import formationBookmarksReducer from "../formationBookmarksReducer";
import sallesReducer from "../sallesReducer";
import fournisseursReducer from "../fournisseursReducer";
import consultantsReducer from "../consultantsReducer";
import modulesCleReducer from "../modulesCleReducer";
import eventsReducer from "../eventsReducer";
import assignmentReducer from "../assignmentReducer";
import eventAttendanceReducer from "../eventAttendanceReducer";
import moduleReducer from "../moduleReducer";
import parcoursReducer from "../parcoursReducer";
import quizReducer from "../quizReducer";
import certificatsReducer from "../certificatsReducer";
import moduleCleContentReducer from "../moduleCleContentReducer";
import moduleCleSectionReducer from "../moduleCleSectionReducer";
import seuilPassageReducer from "../seuilPassageReducer";
import formationSkillReducer from "../formationSkillReducer";
import learnerModulesReducer from "../learnerModulesReducer";
import moduleLearningReducer from "../moduleLearningReducer";

const formationReducers = {
  campagnes: campagnesReducer,
  paramDomainesThemes: paramDomainesThemesReducer,
  formations: formationsReducer,
  catalogues: cataloguesReducer,
  capsules: capsuleReducer,
  demandes: demandesReducer,
  formationBookmarks: formationBookmarksReducer,
  salles: sallesReducer,
  fournisseurs: fournisseursReducer,
  consultants: consultantsReducer,
  modulesCle: modulesCleReducer,
  events: eventsReducer,
  assignments: assignmentReducer,
  eventAttendance: eventAttendanceReducer,
  module: moduleReducer,
  parcours: parcoursReducer,
  quizzes: quizReducer,
  certificats: certificatsReducer,
  moduleCleContent: moduleCleContentReducer,
  moduleCleSection: moduleCleSectionReducer,
  seuilPassage: seuilPassageReducer,
  formationSkill: formationSkillReducer,
  learnerModules: learnerModulesReducer,
  moduleLearning: moduleLearningReducer,
};

export default formationReducers;
